/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'editor-common-extensibility-extension-lozenge-editToggle.done.editing': 'Done editing',
  'editor-common-extensibility-extension-lozenge-editToggle.make.edits': 'Make edits',
  'editor-common-extensibility.macro.button.configure': 'Configure {macroName}',
  'editor.extension.legacyContentHeader': 'Legacy Content',
  'editor.extension.legacyContentHeader.contentHasLimitedFunctionality': 'This content has limited functionality,',
  'editor.extension.legacyContentHeader.learnMore': 'Learn more',
  'editor.trackChanges.removed': 'Removed',
  'editor.trackChanges.toolbarIconLabel': 'View changes',
  'fablric.editor.viewAllInserts': 'View all inserts',
  'fabric.editor.accessToSyncedBlockRequested': 'Access requested',
  'fabric.editor.action': 'Action item',
  'fabric.editor.action.description': 'Create and assign action items',
  'fabric.editor.addAltText': 'Alt text',
  'fabric.editor.addColumnLeft': 'Add column left',
  'fabric.editor.addColumnRight': 'Add column right',
  'fabric.editor.addCommentOnMedia': 'Add comment',
  'fabric.editor.addImageBorder': 'Add border',
  'fabric.editor.addLoomVideo': 'Record a Loom video',
  'fabric.editor.addLoomVideoComment': 'Record a Loom video comment',
  'fabric.editor.addMediaFiles': 'Add image, video, or file',
  'fabric.editor.addRowAbove': 'Add row above',
  'fabric.editor.addRowBelow': 'Add row below',
  'fabric.editor.addUpdatedAltText': 'Add alt text',
  'fabric.editor.ai.ai-panels.actionItemsPageDescription':
    'Use Atlassian Intelligence to find action items and display in a panel',
  'fabric.editor.ai.ai-panels.actionItemsPageTitle': 'Action items panel (Beta)',
  'fabric.editor.ai.ai-panels.summarizePageDescription':
    'Use Atlassian Intelligence to summarize this page and display in a panel',
  'fabric.editor.ai.ai-panels.summarizePageTitle': 'Page summary panel (Beta)',
  'fabric.editor.ai.ai-smart-button.context.reference': 'Selected content',
  'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription':
    'Generates content to be inserted into the update',
  'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': 'Summarizes the content of the update',
  'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': 'Generate',
  'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': 'Ask Atlassian Intelligence',
  'fabric.editor.ai.config.item.action.edit': 'Edit',
  'fabric.editor.ai.config.item.action.insert': 'Insert',
  'fabric.editor.ai.config.item.action.insertAtTop': 'Insert at top',
  'fabric.editor.ai.config.item.action.insertBelow': 'Insert below',
  'fabric.editor.ai.config.item.action.insertBelowOriginal': 'Insert below original',
  'fabric.editor.ai.config.item.action.replace': 'Replace',
  'fabric.editor.ai.config.item.action.replaceTitle': 'Replace title',
  'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip':
    'Title cannot exceed {maxLength} characters',
  'fabric.editor.ai.config.item.action.rovoAgents.contineChatLabel': 'Continue in chat',
  'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': 'Open in Chat',
  'fabric.editor.ai.config.item.addPolish.description': 'Polishes the content to make it more polished',
  'fabric.editor.ai.config.item.addPolish.title': 'Add polish',
  'fabric.editor.ai.config.item.agent.title': 'Atlassian Intelligence Rovo Agent',
  'fabric.editor.ai.config.item.atlas-shorten-update.description': 'Shortens the content to make it more concise',
  'fabric.editor.ai.config.item.atlas-shorten-update.title': 'Shorten update',
  'fabric.editor.ai.config.item.bb.pr.description.description':
    'Creates a pull request description with a summary of changes',
  'fabric.editor.ai.config.item.bb.pr.description.title': 'Create pull request description',
  'fabric.editor.ai.config.item.brainstorm.description': 'Generates a list of ideas for a topic you provide',
  'fabric.editor.ai.config.item.brainstorm.promptHint': 'Tell me the topic...',
  'fabric.editor.ai.config.item.brainstorm.promptLabel': 'Brainstorm',
  'fabric.editor.ai.config.item.brainstorm.title': 'Brainstorm',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentShortTitle': 'Length',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentTitle': 'Adjust length',
  'fabric.editor.ai.config.item.changeTone.casualTone.description': 'Changes the tone of the content to casual',
  'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Casual',
  'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'Casual',
  'fabric.editor.ai.config.item.changeTone.casualTone.title': 'Change tone to casual',
  'fabric.editor.ai.config.item.changeTone.educationalTone.description':
    'Changes the tone of the content to educational',
  'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': 'Educational',
  'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': 'Educational',
  'fabric.editor.ai.config.item.changeTone.educationalTone.title': 'Change tone to educational',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.description': 'Changes the tone of the content to empathetic',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Empathetic',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': 'Empathetic',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.title': 'Change tone to empathetic',
  'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': 'Change tone to ...',
  'fabric.editor.ai.config.item.changeTone.neutralTone.description': 'Changes the tone of the content to neutral',
  'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Neutral',
  'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': 'Neutral',
  'fabric.editor.ai.config.item.changeTone.neutralTone.title': 'Change tone to neutral',
  'fabric.editor.ai.config.item.changeTone.professionalTone.description':
    'Changes the tone of the content to professional',
  'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Professional',
  'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': 'Professional',
  'fabric.editor.ai.config.item.changeTone.professionalTone.title': 'Change tone to professional',
  'fabric.editor.ai.config.item.convertToBulletList.description': 'Reformats content to a bulleted list',
  'fabric.editor.ai.config.item.convertToBulletList.title': 'Convert to bulleted list',
  'fabric.editor.ai.config.item.convertToTable.description': 'Reformats content to a table with headings',
  'fabric.editor.ai.config.item.convertToTable.title': 'Convert to table',
  'fabric.editor.ai.config.item.draftReply.description':
    'Drafts a reply based on issues similar to the one you’re working on',
  'fabric.editor.ai.config.item.draftReply.heroPromptDescription':
    'Enhances the reply based on issues similar to the one you’re working on',
  'fabric.editor.ai.config.item.draftReply.heroPromptTitle': 'Suggest reply',
  'fabric.editor.ai.config.item.draftReply.title': 'Draft reply',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description': 'Fixes spelling and grammar mistakes',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title': 'Spelling & grammar',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': 'Fix spelling & grammar',
  'fabric.editor.ai.config.item.enhance.improveWriting.description':
    'Enhances clarity, structure, and tone for better engagement and comprehension',
  'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': 'Improve writing',
  'fabric.editor.ai.config.item.enhance.improveWriting.title': 'Improve writing',
  'fabric.editor.ai.config.item.findActionItems.description': 'Finds action items in the content you provide',
  'fabric.editor.ai.config.item.findActionItems.title': 'Find action items',
  'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint':
    'Select from below (free generate is disabled in Elevate at this time)',
  'fabric.editor.ai.config.item.generateContent.promptHint': 'Write with AI or select from below',
  'fabric.editor.ai.config.item.generateContent.rovoPromptHint': 'Write with Rovo or select from below',
  'fabric.editor.ai.config.item.generateEscalationNotes.description':
    'Generates escalation notes based on the issue context',
  'fabric.editor.ai.config.item.generateEscalationNotes.title': 'Generate escalation notes',
  'fabric.editor.ai.config.item.improveDescription.default.description':
    'Restructure the issue description based on the issue type',
  'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': 'Improve description',
  'fabric.editor.ai.config.item.makeLonger.description': 'Expands the content based on the context you provide',
  'fabric.editor.ai.config.item.makeLonger.title': 'Make longer',
  'fabric.editor.ai.config.item.range.agent.description': 'No description',
  'fabric.editor.ai.config.item.range.agent.prompt.hint': 'Tell the Agent to write anything or choose from below',
  'fabric.editor.ai.config.item.rephrase.description': 'Creates a suggestion for rewriting your sentences',
  'fabric.editor.ai.config.item.rephrase.title': 'Rephrase',
  'fabric.editor.ai.config.item.shorten.description': 'Shortens the content to make it more concise',
  'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': 'Make shorter',
  'fabric.editor.ai.config.item.shorten.title': 'Make shorter',
  'fabric.editor.ai.config.item.suggest.description': 'Suggests a title for content you provide',
  'fabric.editor.ai.config.item.suggest.title': 'Suggest a title',
  'fabric.editor.ai.config.item.summarize.description':
    "Creates a summary of the text you're working on, highlighting key points",
  'fabric.editor.ai.config.item.summarize.dropdownItem.title': 'Summarize writing',
  'fabric.editor.ai.config.item.summarize.title': 'Summarize writing',
  'fabric.editor.ai.config.item.translate.chineseSimplified': 'Chinese (Simplified)',
  'fabric.editor.ai.config.item.translate.chineseTraditional': 'Chinese (Traditional)',
  'fabric.editor.ai.config.item.translate.czech': 'Czech',
  'fabric.editor.ai.config.item.translate.danish': 'Danish',
  'fabric.editor.ai.config.item.translate.dutch': 'Dutch',
  'fabric.editor.ai.config.item.translate.english': 'English',
  'fabric.editor.ai.config.item.translate.finnish': 'Finnish',
  'fabric.editor.ai.config.item.translate.french': 'French',
  'fabric.editor.ai.config.item.translate.german': 'German',
  'fabric.editor.ai.config.item.translate.hungarian': 'Hungarian',
  'fabric.editor.ai.config.item.translate.italian': 'Italian',
  'fabric.editor.ai.config.item.translate.japanese': 'Japanese',
  'fabric.editor.ai.config.item.translate.korean': 'Korean',
  'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': 'Translate',
  'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': 'Translate to ...',
  'fabric.editor.ai.config.item.translate.norwegian': 'Norwegian',
  'fabric.editor.ai.config.item.translate.polish': 'Polish',
  'fabric.editor.ai.config.item.translate.portugueseBrazilian': 'Portuguese (Brazilian)',
  'fabric.editor.ai.config.item.translate.russian': 'Russian',
  'fabric.editor.ai.config.item.translate.spanish': 'Spanish',
  'fabric.editor.ai.config.item.translate.swedish': 'Swedish',
  'fabric.editor.ai.config.item.translate.thai': 'Thai',
  'fabric.editor.ai.config.item.translate.turkish': 'Turkish',
  'fabric.editor.ai.config.item.translate.ukrainian': 'Ukrainian',
  'fabric.editor.ai.config.item.translate.vietnamese': 'Vietnamese',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.description':
    "Translates the text you're working on to Chinese (Simplified)",
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': 'Translate to Chinese (Simplified)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.description':
    "Translates the text you're working on to Chinese (Traditional)",
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': 'Translate to Chinese (Traditional)',
  'fabric.editor.ai.config.item.translateTo.czech.description': "Translates the text you're working on to Czech",
  'fabric.editor.ai.config.item.translateTo.czech.title': 'Translate to Czech',
  'fabric.editor.ai.config.item.translateTo.danish.description': "Translates the text you're working on to Danish",
  'fabric.editor.ai.config.item.translateTo.danish.title': 'Translate to Danish',
  'fabric.editor.ai.config.item.translateTo.dutch.description': "Translates the text you're working on to Dutch",
  'fabric.editor.ai.config.item.translateTo.dutch.title': 'Translate to Dutch',
  'fabric.editor.ai.config.item.translateTo.english.description': "Translates the text you're working on to English",
  'fabric.editor.ai.config.item.translateTo.english.title': 'Translate to English',
  'fabric.editor.ai.config.item.translateTo.finnish.description': "Translates the text you're working on to Finnish",
  'fabric.editor.ai.config.item.translateTo.finnish.title': 'Translate to Finnish',
  'fabric.editor.ai.config.item.translateTo.french.description': "Translates the text you're working on to French",
  'fabric.editor.ai.config.item.translateTo.french.title': 'Translate to French',
  'fabric.editor.ai.config.item.translateTo.german.description': "Translates the text you're working on to German",
  'fabric.editor.ai.config.item.translateTo.german.title': 'Translate to German',
  'fabric.editor.ai.config.item.translateTo.hungarian.description':
    "Translates the text you're working on to Hungarian",
  'fabric.editor.ai.config.item.translateTo.hungarian.title': 'Translate to Hungarian',
  'fabric.editor.ai.config.item.translateTo.italian.description': "Translates the text you're working on to Italian",
  'fabric.editor.ai.config.item.translateTo.italian.title': 'Translate to Italian',
  'fabric.editor.ai.config.item.translateTo.japanese.description': "Translates the text you're working on to Japanese",
  'fabric.editor.ai.config.item.translateTo.japanese.title': 'Translate to Japanese',
  'fabric.editor.ai.config.item.translateTo.korean.description': "Translates the text you're working on to Korean",
  'fabric.editor.ai.config.item.translateTo.korean.title': 'Translate to Korean',
  'fabric.editor.ai.config.item.translateTo.norwegian.description':
    "Translates the text you're working on to Norwegian",
  'fabric.editor.ai.config.item.translateTo.norwegian.title': 'Translate to Norwegian',
  'fabric.editor.ai.config.item.translateTo.polish.description': "Translates the text you're working on to Polish",
  'fabric.editor.ai.config.item.translateTo.polish.title': 'Translate to Polish',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description':
    "Translates the text you're working on to Portuguese (Brazilian)",
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': 'Translate to Portuguese (Brazilian)',
  'fabric.editor.ai.config.item.translateTo.russian.description': "Translates the text you're working on to Russian",
  'fabric.editor.ai.config.item.translateTo.russian.title': 'Translate to Russian',
  'fabric.editor.ai.config.item.translateTo.spanish.description': "Translates the text you're working on to Spanish",
  'fabric.editor.ai.config.item.translateTo.spanish.title': 'Translate to Spanish',
  'fabric.editor.ai.config.item.translateTo.swedish.description': "Translates the text you're working on to Swedish",
  'fabric.editor.ai.config.item.translateTo.swedish.title': 'Translate to Swedish',
  'fabric.editor.ai.config.item.translateTo.thai.description': "Translates the text you're working on to Thai",
  'fabric.editor.ai.config.item.translateTo.thai.title': 'Translate to Thai',
  'fabric.editor.ai.config.item.translateTo.turkish.description': "Translates the text you're working on to Turkish",
  'fabric.editor.ai.config.item.translateTo.turkish.title': 'Translate to Turkish',
  'fabric.editor.ai.config.item.translateTo.ukrainian.description':
    "Translates the text you're working on to Ukrainian",
  'fabric.editor.ai.config.item.translateTo.ukrainian.title': 'Translate to Ukrainian',
  'fabric.editor.ai.config.item.translateTo.vietnamese.description':
    "Translates the text you're working on to Vietnamese",
  'fabric.editor.ai.config.item.translateTo.vietnamese.title': 'Translate to Vietnamese',
  'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'Change tone',
  'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Rewrite',
  'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': 'Translate',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'Page title',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'Page',
  'fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage':
    "We're having issues and can't generate a response right now. Try again later.",
  'fabric.editor.ai.experience-application.documentInsertError':
    "We're having trouble inserting the response. Close the dialog and try again.",
  'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage':
    "We're having trouble generating the preview. Close the dialog and try again.",
  'fabric.editor.ai.experience-application.rateLimitEnforced':
    'We’ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or read about <link>excessive use of AI</link>.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again.",
  'fabric.editor.ai.experience-application.unhandledErrorMessage':
    "We're having trouble. Close the dialog and try again.",
  'fabric.editor.ai.experience.adfStreamingError': "Our apologies, we couldn't get a response.",
  'fabric.editor.ai.experience.aifcAdfStreamingError': 'Our apologies, we couldn’t get a response.',
  'fabric.editor.ai.experience.aifcApiError': 'An unknown error occurred.',
  'fabric.editor.ai.experience.aifcApiErrorRetry': 'An unknown error occurred. Please reload and try again.',
  'fabric.editor.ai.experience.aifcAupViolationMessage':
    'Content does not comply with our <link>Acceptable Use Policy</link>.',
  'fabric.editor.ai.experience.aifcHipaaContentError':
    'Your content contains links to HIPAA restricted content. Remove links and try again.',
  'fabric.editor.ai.experience.aifcInputTooShortError':
    'More content needed to complete your request. Please select more content and try again.',
  'fabric.editor.ai.experience.aifcInternalServerError':
    'Our apologies, we couldn’t get a response. Try again in 5 minutes or <link>check Rovo status</link>.',
  'fabric.editor.ai.experience.aifcRateLimitEnforced':
    'You’ve reached the <link>maximum number of requests</link>. Try again in 5 minutes.',
  'fabric.editor.ai.experience.aifcTokenLimitExceeded':
    'There’s too much content to process. Select less content and try again.',
  'fabric.editor.ai.experience.apiError': 'We couldn’t get a response, please try again.',
  'fabric.editor.ai.experience.aupViolationMessage':
    'Your prompt or content might not comply with our Acceptable Use Policy. Please review both and refer to our <link>Acceptable Use Policy</link> if needed. If the problem persists, consider trying a different prompt or content.',
  'fabric.editor.ai.experience.browseMore.agents': 'Browse Agents',
  'fabric.editor.ai.experience.dialogAriaLabel': 'Atlassian Intelligence Dialog',
  'fabric.editor.ai.experience.discardMessagePrompt': 'Do you want to discard your prompt?',
  'fabric.editor.ai.experience.discardMessageResponse': 'Do you want to discard your response?',
  'fabric.editor.ai.experience.discardStreamingInDocumennt': 'Cancel request and discard response?',
  'fabric.editor.ai.experience.elevateDisabledGenetateError': 'Free generate is disabled in Elevate at this time.',
  'fabric.editor.ai.experience.engagementBannerLinksText':
    '🚀 You can now paste links 🔗 to Jira and Confluence content in your prompts.',
  'fabric.editor.ai.experience.footerRightText.agents': 'Powered by Rovo',
  'fabric.editor.ai.experience.generatingAiResponse': 'Generating',
  'fabric.editor.ai.experience.hipaaContentError':
    'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content. Please remove these links and try again.',
  'fabric.editor.ai.experience.inputTooShortError':
    'The content is too short to summarize. Please add more and try again.',
  'fabric.editor.ai.experience.internalServerError':
    'Atlassian Intelligence (AI) isn’t responding. Try again later or <link>check the status of AI</link>.',
  'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
  'fabric.editor.ai.experience.loadingTitle': 'Generating',
  'fabric.editor.ai.experience.messageTemplateAnalysingQuery': 'Analyzing: Reviewing your question.',
  'fabric.editor.ai.experience.messageTemplateContentSearch': 'Searching: One moment while we search for information.',
  'fabric.editor.ai.experience.messageTemplateNextBestTask': 'Searching: One moment while we search Jira.',
  'fabric.editor.ai.experience.messageTemplatePageHydration': 'Searching: One moment while we search the page.',
  'fabric.editor.ai.experience.noResultsSuggestion': 'No results',
  'fabric.editor.ai.experience.noTextualContentError':
    'More content needed to complete your request. Please select more content and try again.',
  'fabric.editor.ai.experience.responseTooSimilarMessage':
    'Atlassian Intelligence has no suggestions at this time. Feel free to try a different prompt or content.',
  'fabric.editor.ai.experience.showMoreButton': 'Show more',
  'fabric.editor.ai.experience.suggestionGroupHeading.actions': 'Actions',
  'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Agents',
  'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian intelligence',
  'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': 'Knowledge source',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Rovo agents',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Rovo agents ({numberOfAgents})',
  'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount': 'Use a Rovo agent ({numberOfAgents})',
  'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': 'Use general knowledge',
  'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': 'Use knowledge from your organization',
  'fabric.editor.ai.proactive.askAIButtonLabel.non-final': 'Ask AI',
  'fabric.editor.ai.proactive.beta.label.non-final': 'BETA',
  'fabric.editor.ai.proactive.close.label.non-final': 'Close',
  'fabric.editor.ai.proactive.enableSuggestionsButtonLabel.non-final': 'Turn on',
  'fabric.editor.ai.proactive.enableSuggestionsState.description.non-final':
    'Turn on suggested edits to quickly preview content improvements.',
  'fabric.editor.ai.proactive.enableSuggestionsState.title.non-final': 'You create. We polish.',
  'fabric.editor.ai.proactive.error.markdownErrorMessage':
    "We're having trouble generating the preview. Close the dialog and try again.",
  'fabric.editor.ai.proactive.error.unhandledErrorMessage': "We're having trouble. Close the dialog and try again.",
  'fabric.editor.ai.proactive.findingMoreSuggestionsLoadingLabel.non-final': 'Finding more suggestions',
  'fabric.editor.ai.proactive.findingSuggestionsLabel.non-final': 'Finding suggestions',
  'fabric.editor.ai.proactive.findingSuggestionsLoadingLabel.non-final': 'Finding suggestions',
  'fabric.editor.ai.proactive.loading.iconAltText.non-final': 'Loading icon',
  'fabric.editor.ai.proactive.moreActions.label.non-final': 'More actions',
  'fabric.editor.ai.proactive.moreMenu.giveFeedback.non-final': 'Give feedback',
  'fabric.editor.ai.proactive.moreMenu.label.non-final': 'more',
  'fabric.editor.ai.proactive.moreMenu.manageSuggestions.non-final': 'Manage Suggestions',
  'fabric.editor.ai.proactive.moreMenu.manageSuggestionsTitle.non-final': 'Manage suggestions',
  'fabric.editor.ai.proactive.moreMenu.toggleAllPanelSuggestionsDescription.non-final':
    'Use panels to make your message stand out.',
  'fabric.editor.ai.proactive.moreMenu.toggleAllPanelSuggestionsTitle.non-final': 'Panels',
  'fabric.editor.ai.proactive.moreMenu.toggleAllSuggestionsDescription.non-final':
    'Toggle to turn suggested edits on or off.',
  'fabric.editor.ai.proactive.moreMenu.toggleAllSuggestionsTitle.non-final': 'All suggestions',
  'fabric.editor.ai.proactive.moreMenu.toggleErrorPanelDescription.non-final': 'Transform text into a red error panel.',
  'fabric.editor.ai.proactive.moreMenu.toggleErrorPanelTitle.non-final': 'Error panel',
  'fabric.editor.ai.proactive.moreMenu.toggleFormatParagraphDescription.non-final':
    'Suggestions for writing, lists, content structure, and spelling.',
  'fabric.editor.ai.proactive.moreMenu.toggleFormatParagraphTitle.non-final': 'Enhance content',
  'fabric.editor.ai.proactive.moreMenu.toggleInfoPanelDescription.non-final':
    'Transform text into a blue information panel.',
  'fabric.editor.ai.proactive.moreMenu.toggleInfoPanelTitle.non-final': 'Info panel',
  'fabric.editor.ai.proactive.moreMenu.toggleNotePanelDescription.non-final':
    'Transform text into a purple note panel.',
  'fabric.editor.ai.proactive.moreMenu.toggleNotePanelTitle.non-final': 'Note panel',
  'fabric.editor.ai.proactive.moreMenu.toggleSplitParagraphDescription.non-final':
    'Add paragraph breaks to separate key ideas.',
  'fabric.editor.ai.proactive.moreMenu.toggleSplitParagraphTitle.non-final': 'Paragraph break',
  'fabric.editor.ai.proactive.moreMenu.toggleSuccessPanelDescription.non-final':
    'Transform text into a green success panel.',
  'fabric.editor.ai.proactive.moreMenu.toggleSuccessPanelTitle.non-final': 'Success panel',
  'fabric.editor.ai.proactive.moreMenu.toggleTableDescription.non-final':
    'Format content in a table to improve readability.',
  'fabric.editor.ai.proactive.moreMenu.toggleTableTitle.non-final': 'Table',
  'fabric.editor.ai.proactive.moreMenu.toggleWarningPanelDescription.non-final':
    'Transform text into a yellow warning panel.',
  'fabric.editor.ai.proactive.moreMenu.toggleWarningPanelTitle.non-final': 'Warning panel',
  'fabric.editor.ai.proactive.noSuggestionsState.description.non-final':
    'You can also ask AI to improve your page with requests such as <i>Add a table of contents</i> or <i>Create headings</i>.',
  'fabric.editor.ai.proactive.noSuggestionsState.title.non-final': 'Suggestions will appear here',
  'fabric.editor.ai.proactive.preview.dismissProactiveRecommendation.non-final': 'Dismiss',
  'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': 'Insert below',
  'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': 'Replace',
  'fabric.editor.ai.proactive.recommendation.convertToErrorPanel.description.non-final':
    'Use a red error panel to make your message stand out.',
  'fabric.editor.ai.proactive.recommendation.convertToErrorPanel.title.non-final': 'Frame with error panel',
  'fabric.editor.ai.proactive.recommendation.convertToInfoPanel.description.non-final':
    'Use a blue info panel to make your message stand out.',
  'fabric.editor.ai.proactive.recommendation.convertToInfoPanel.title.non-final': 'Frame with info panel',
  'fabric.editor.ai.proactive.recommendation.convertToNotePanel.description.non-final':
    'Use a purple note panel to make your message stand out.',
  'fabric.editor.ai.proactive.recommendation.convertToNotePanel.title.non-final': 'Frame with note panel',
  'fabric.editor.ai.proactive.recommendation.convertToSuccessPanel.description.non-final':
    'Use a green success panel to make your message stand out.',
  'fabric.editor.ai.proactive.recommendation.convertToSuccessPanel.title.non-final': 'Frame with success panel',
  'fabric.editor.ai.proactive.recommendation.convertToTable.description.non-final':
    'Format content in a table to improve readability.',
  'fabric.editor.ai.proactive.recommendation.convertToTable.title.non-final': 'Format in table',
  'fabric.editor.ai.proactive.recommendation.convertToWarnPanel.description.non-final':
    'Use a yellow warning panel to make your message stand out.',
  'fabric.editor.ai.proactive.recommendation.convertToWarnPanel.title.non-final': 'Frame with warning panel',
  'fabric.editor.ai.proactive.recommendation.default.description.non-final': 'A suggestion to improve the content.',
  'fabric.editor.ai.proactive.recommendation.default.title.non-final': 'Suggestion',
  'fabric.editor.ai.proactive.recommendation.dismiss.button.non-final': 'Dismiss',
  'fabric.editor.ai.proactive.recommendation.formatParagraph.description.non-final':
    'Clarify content writing and structure.',
  'fabric.editor.ai.proactive.recommendation.formatParagraph.title.non-final': 'Enhance content',
  'fabric.editor.ai.proactive.recommendation.formatParagraphClarity.description.non-final':
    'Simplify phrasing and grammar.',
  'fabric.editor.ai.proactive.recommendation.formatParagraphClarity.title.non-final': 'Clarify writing',
  'fabric.editor.ai.proactive.recommendation.formatParagraphList.description.non-final':
    'Turn content into a scannable list.',
  'fabric.editor.ai.proactive.recommendation.formatParagraphList.title.non-final': 'Create list',
  'fabric.editor.ai.proactive.recommendation.formatParagraphSpellcheck.description.non-final':
    'Spot and correct spelling errors.',
  'fabric.editor.ai.proactive.recommendation.formatParagraphSpellcheck.title.non-final': 'Fix spelling',
  'fabric.editor.ai.proactive.recommendation.formatParagraphStructure.description.non-final':
    'Add paragraph breaks and headings.',
  'fabric.editor.ai.proactive.recommendation.formatParagraphStructure.title.non-final': 'Improve structure',
  'fabric.editor.ai.proactive.recommendation.preview.button.non-final': 'Preview',
  'fabric.editor.ai.proactive.recommendation.replace.button.non-final': 'Replace',
  'fabric.editor.ai.proactive.recommendation.splitParagraph.description.non-final':
    'Add paragraph breaks to separate key ideas.',
  'fabric.editor.ai.proactive.recommendation.splitParagraph.title.non-final': 'Divide paragraph',
  'fabric.editor.ai.proactive.reloadSuggestionsButtonLabel.non-final': 'View past suggestions',
  'fabric.editor.ai.proactive.reloadSuggestionsState.description.non-final': 'Any new suggestions will appear here.',
  'fabric.editor.ai.proactive.reloadSuggestionsState.title.non-final': 'Your content’s looking good',
  'fabric.editor.ai.proactive.spellingAndGrammar.label.non-final': 'Spelling and grammar',
  'fabric.editor.ai.proactive.suggestions.title.non-final': 'Suggestions',
  'fabric.editor.ai.screens.preview.convoAIBeta': 'Content generation requests that reference URLs is in beta.',
  'fabric.editor.ai.selectionToolbar.define.disabled.tooltip': 'Highlight a term, acronym, or abbreviation',
  'fabric.editor.ai.selectionToolbar.define.title': 'Define',
  'fabric.editor.ai.telepointer.rovo': 'Rovo',
  'fabric.editor.ai.toolbar.DefineDropdownIconTitle.title': 'Define',
  'fabric.editor.ai.toolbar.adjustLength.title': 'Adjust length',
  'fabric.editor.ai.toolbar.askAI.title': 'Ask AI',
  'fabric.editor.ai.toolbar.askRovo.title': 'Ask Rovo',
  'fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand': "Ask Rovo {key}+'",
  'fabric.editor.ai.toolbar.askRovoAiSplitButton.label': 'Ask Rovo AI',
  'fabric.editor.ai.toolbar.changeTone.title': 'Change tone',
  'fabric.editor.ai.toolbar.changeToneOptions.title': 'Change tone options',
  'fabric.editor.ai.toolbar.improveWriting.title': 'Improve writing',
  'fabric.editor.ai.toolbar.improveWriting.tooltip':
    'Tell Atlassian Intelligence to improve the writing of your selection',
  'fabric.editor.ai.toolbar.makeLonger.title': 'Make longer',
  'fabric.editor.ai.toolbar.makeShorter.title': 'Make shorter',
  'fabric.editor.ai.toolbar.moreCasualTone.title': 'More casual',
  'fabric.editor.ai.toolbar.moreEmpatheticTone.title': 'More empathetic',
  'fabric.editor.ai.toolbar.moreProfessionalTone.title': 'More professional',
  'fabric.editor.ai.toolbar.moreRovoOptions.label': 'More Rovo options',
  'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
  'fabric.editor.ai.toolbar.spellingAndGrammar.title': 'Fix spelling and grammar',
  'fabric.editor.ai.toolbar.summarize.title': 'Summarize',
  'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
  'fabric.editor.ai.toolbar.translate.title': 'Translate',
  'fabric.editor.ai.toolbar.translateOptions.label': 'Translate options',
  'fabric.editor.ai.toolbar.tryAI.title': 'Try AI',
  'fabric.editor.ai.toolbar.tryAI.tooltip': 'Open Atlassian Intelligence',
  'fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand': "Ask AI {key}+'",
  'fabric.editor.alignCenter': 'Align center',
  'fabric.editor.alignImageCenter': 'Align center',
  'fabric.editor.alignImageLeft': 'Align left',
  'fabric.editor.alignImageRight': 'Align right',
  'fabric.editor.alignLeft': 'Align left',
  'fabric.editor.alignRight': 'Align right',
  'fabric.editor.alignTableCenter': 'Align center',
  'fabric.editor.alignTableLeft': 'Align left',
  'fabric.editor.alignment': 'Text alignment',
  'fabric.editor.altText': 'Alt text',
  'fabric.editor.alttext.validation': 'Please remove any special characters in alt text.',
  'fabric.editor.annotationToolbar': 'Annotation toolbar',
  'fabric.editor.backLink': 'Go back',
  'fabric.editor.backgroundColor': 'Background color',
  'fabric.editor.block.menu.codeblock': 'Code block',
  'fabric.editor.block.menu.copy.block': 'Copy block',
  'fabric.editor.block.menu.copy.content': 'Copy content',
  'fabric.editor.block.menu.copy.link': 'Copy link',
  'fabric.editor.block.menu.copy.link.to.block': 'Copy link to block',
  'fabric.editor.block.menu.copy.synced.block': 'Copy synced block',
  'fabric.editor.block.menu.create.synced.block': 'Create synced block',
  'fabric.editor.block.menu.decision': 'Decision',
  'fabric.editor.block.menu.delete.block': 'Delete',
  'fabric.editor.block.menu.layout': 'Layout',
  'fabric.editor.block.menu.link.copied.to.clipboard': 'Link copied to clipboard',
  'fabric.editor.block.menu.move.down': 'Move down',
  'fabric.editor.block.menu.move.up': 'Move up',
  'fabric.editor.block.menu.new.lozenge': 'New',
  'fabric.editor.block.menu.paragraph': 'Paragraph',
  'fabric.editor.block.menu.turn.into': 'Turn into',
  'fabric.editor.blockCardUnavailable': 'The inline link is inside {node} and cannot have its view changed',
  'fabric.editor.blockControlDelete': 'Delete',
  'fabric.editor.blockControlDragHandleMove': 'Drag to move',
  'fabric.editor.blockControlDragHandleMoveOrOpen': 'Drag to move {br} Click to open menu',
  'fabric.editor.blockControlDragHandleRearrange': 'Drag to rearrange',
  'fabric.editor.blockControlInsert': 'Insert',
  'fabric.editor.blockControlMoveDown': 'Move down',
  'fabric.editor.blockControlMoveLeft': 'Move left',
  'fabric.editor.blockControlMoveRight': 'Move right',
  'fabric.editor.blockControlMoveUp': 'Move up',
  'fabric.editor.blockControlMovedDown': 'Content has been moved down',
  'fabric.editor.blockControlMovedUp': 'Content has been moved up',
  'fabric.editor.blockDescription': 'Display more information about a link, including a summary and actions',
  'fabric.editor.blockTitle': 'Card',
  'fabric.editor.blockquote': 'a quote',
  'fabric.editor.blockquote.description': 'Insert a quote or citation',
  'fabric.editor.blockquote2': 'Quote',
  'fabric.editor.bold': 'Bold',
  'fabric.editor.breakout.resizeCodeBlock': 'Resize code snippet',
  'fabric.editor.breakout.resizeElement': 'Resize element',
  'fabric.editor.breakout.resizeExpand': 'Resize expand',
  'fabric.editor.breakout.resizeLayout': 'Resize layout',
  'fabric.editor.breakoutFullWidthLabel': 'Full-width',
  'fabric.editor.breakoutMaxWidthLabel': 'Max-width',
  'fabric.editor.breakoutWideWidthLabel': 'Wide',
  'fabric.editor.bug': 'Bug',
  'fabric.editor.bulletedList': 'Bulleted list',
  'fabric.editor.canNotSortTable': "⚠️ You can't sort a table with merged cells",
  'fabric.editor.cancelButton': 'Cancel',
  'fabric.editor.captionPlaceholder': 'Add a caption',
  'fabric.editor.captionPlaceholderWithDoubleClickPrompt': 'Add a caption - double-click to preview',
  'fabric.editor.cardFloatingControls': 'Card options',
  'fabric.editor.cellBackground': 'Cell background',
  'fabric.editor.cellOptions': 'Cell options',
  'fabric.editor.checkUncheckActionItem': 'Toggle action item',
  'fabric.editor.clearAltTextEdit': 'Clear alt text',
  'fabric.editor.clearCells': 'Clear {0, plural, one {cell} other {cells}}',
  'fabric.editor.clearFormatting': 'Clear formatting',
  'fabric.editor.clearLink': 'Clear link',
  'fabric.editor.clearLinkText': 'Clear text',
  'fabric.editor.closeAltTextEdit': 'Back',
  'fabric.editor.closeFindReplaceDialog': 'Close',
  'fabric.editor.closeHelpDialog': 'Close help dialog',
  'fabric.editor.code': 'Code',
  'fabric.editor.code.on': '{textFormattingOff}, Code On',
  'fabric.editor.codeBidiWarningLabel':
    'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
  'fabric.editor.codeBlockCopyButton.copiedToClipboard': 'Copied!',
  'fabric.editor.codeBlockCopyButton.copyToClipboard': 'Copy as text',
  'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': 'Turn off wrap',
  'fabric.editor.codeBlockWrapButton.wrapCodeBlock': 'Turn on wrap',
  'fabric.editor.codeblock': 'Code snippet',
  'fabric.editor.codeblock.description': 'Display code with syntax highlighting',
  'fabric.editor.collapseNode': 'Collapse content',
  'fabric.editor.collapseTable': 'Collapse table',
  'fabric.editor.colorPicker.menuLabel': 'Color picker menu',
  'fabric.editor.columnDragHandle': 'Column options',
  'fabric.editor.columnMovedLeft': 'Column moved left to {index} of {total}',
  'fabric.editor.columnMovedRight': 'Column moved right to {index} of {total}',
  'fabric.editor.columnSelected': 'Column {index} of {total} selected',
  'fabric.editor.columns': 'Layouts',
  'fabric.editor.columns.advanced.layout.description':
    'Insert {numberOfColumns} equal {numberOfColumns, plural, one {column} other {columns}}',
  'fabric.editor.columns.advanced.layout.single.description': 'Insert a single column layout',
  'fabric.editor.columns.description': 'Structure your page using sections',
  'fabric.editor.columnsAreInserted':
    '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
  'fabric.editor.columnsAreRemoved':
    '{count, plural, one {The column has been} other {{count} columns have been}} removed',
  'fabric.editor.configFailedToLoad': 'Failed to load',
  'fabric.editor.configPanel.cancel': 'Cancel',
  'fabric.editor.configPanel.close': 'Close',
  'fabric.editor.configPanel.customSelect.createOption': 'Create',
  'fabric.editor.configPanel.dateRange.custom.from': 'From',
  'fabric.editor.configPanel.dateRange.custom.to': 'To',
  'fabric.editor.configPanel.dateRange.grouping.collapse': 'Collapse',
  'fabric.editor.configPanel.dateRange.grouping.expand': 'Expand',
  'fabric.editor.configPanel.dateRange.option.custom': 'Custom',
  'fabric.editor.configPanel.documentation': 'Documentation',
  'fabric.editor.configPanel.errorBoundary.note':
    "We've let the team know. You can still edit and publish this page, or check the error console for more information.",
  'fabric.editor.configPanel.errorBoundary.title': 'Something went wrong.',
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio': 'Can not combine isMultiple with style: radio',
  'fabric.editor.configPanel.formType.addField': 'Add field',
  'fabric.editor.configPanel.formType.removeField': 'Remove field',
  'fabric.editor.configPanel.help': 'Need help?',
  'fabric.editor.configPanel.invalid': 'Invalid field',
  'fabric.editor.configPanel.required': 'Required field',
  'fabric.editor.configPanel.submit': 'Submit',
  'fabric.editor.contextPanel.panelContentLabel': 'Scrollable context panel content',
  'fabric.editor.contextPanel.panelLabel': 'Context panel',
  'fabric.editor.copiedToClipboard': 'Copied!',
  'fabric.editor.copySyncBlock': 'Copy',
  'fabric.editor.copySyncBlockTooltip': 'Copy reference to clipboard',
  'fabric.editor.copyToClipboard': 'Copy',
  'fabric.editor.cornerControl': 'Highlight table',
  'fabric.editor.createComment': 'Comment',
  'fabric.editor.createCommentDisabled':
    'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
  'fabric.editor.createCommentInvalid': 'You can only comment on text and headings',
  'fabric.editor.createSyncBlockLabel': 'Create synced block',
  'fabric.editor.customPanel': 'Custom panel',
  'fabric.editor.customPanel.description': 'Add a note with an emoji and colored background',
  'fabric.editor.datasource.assetsObjects.description':
    'Insert objects from Assets in Jira Service Management with search and filtering',
  'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'Assets',
  'fabric.editor.datasource.confluenceSearch': 'Insert Confluence list',
  'fabric.editor.datasource.confluenceSearch.description':
    'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
  'fabric.editor.datasource.jiraIssue': 'Jira Issues',
  'fabric.editor.datasource.jiraIssue.description':
    'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
  'fabric.editor.datasource.jiraIssue.description.issue-term-refresh':
    'Insert Jira work items from Jira Cloud with enhanced search, filtering, and configuration.',
  'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Jira Work Items',
  'fabric.editor.datasourceAppearanceTitle': 'List',
  'fabric.editor.datasourceTitle': 'Edit search query',
  'fabric.editor.date': 'Date',
  'fabric.editor.date.description': 'Add a date using a calendar',
  'fabric.editor.datePickerOpenedAlert': 'Date editor popup opened, press Tab to access popup',
  'fabric.editor.decision': 'Decision',
  'fabric.editor.decision.description': 'Capture decisions so they’re easy to track',
  'fabric.editor.decisionPlaceholder': 'Add a decision…',
  'fabric.editor.decreaseElementSize': 'Decrease element size',
  'fabric.editor.decreaseSize': 'Decrease table or media size',
  'fabric.editor.defaultAltText': 'Document',
  'fabric.editor.delete': 'Delete',
  'fabric.editor.deleteConfirmationModalCancelButton': 'Cancel',
  'fabric.editor.deleteConfirmationModalDeleteButton': 'Delete',
  'fabric.editor.deleteConfirmationModalDescriptionSingle':
    'Deleting this content will also remove {syncBlockCount, plural, one {a synced block. References to this block} other {# synced blocks. References to these blocks}} in other locations will show an error. Continue with deletion?',
  'fabric.editor.deleteConfirmationModalTitle': "You're about to delete synced content",
  'fabric.editor.description': 'Description',
  'fabric.editor.displayBlock': 'Display card',
  'fabric.editor.displayEmbed': 'Display embed',
  'fabric.editor.displayInline': 'Display inline',
  'fabric.editor.displayLink': 'Display as text',
  'fabric.editor.displayOptionUnavailableInParentNode': "This display option isn't available inside {node}",
  'fabric.editor.displayText': 'Text to display',
  'fabric.editor.distributeColumns': 'Distribute columns',
  'fabric.editor.dragHandleZone': 'Activate drag handle zone',
  'fabric.editor.dropPlaceholderLabel': 'Document',
  'fabric.editor.ecombedDescription': 'Display an interactive preview of a link',
  'fabric.editor.edit': 'Edit',
  'fabric.editor.edit.datasource': 'Edit search query',
  'fabric.editor.edit.searchInput': 'Add a link',
  'fabric.editor.editAccessTitle': 'You need edit access',
  'fabric.editor.editAltText': 'Edit alt text',
  'fabric.editor.editDatasourceStandalone': 'Edit',
  'fabric.editor.editDatasourceStandaloneTooltip': 'Edit search query',
  'fabric.editor.editDateText': 'Edit Date',
  'fabric.editor.editDropdownEditDatasourceTitle': 'Edit search query',
  'fabric.editor.editDropdownEditLinkTitle': 'Edit link',
  'fabric.editor.editDropdownExpandIconLabel': 'Expand dropdown menu',
  'fabric.editor.editDropdownTriggerTitle': 'Edit',
  'fabric.editor.editLink': 'Edit link',
  'fabric.editor.editMode.inviteToEditButton.title': 'Invite to edit',
  'fabric.editor.editSourceLabel': 'Edit source',
  'fabric.editor.editSourceTooltip': 'Edit at the source location',
  'fabric.editor.editSourceTooltipDisabled': 'Source link is not currently available',
  'fabric.editor.editStatusColor': 'Edit Status Color',
  'fabric.editor.editStatusText': 'Edit Status',
  'fabric.editor.editableContentLabel': 'Editable content',
  'fabric.editor.editorHelp': 'Editor help',
  'fabric.editor.editors': 'Editors',
  'fabric.editor.elementBrowser.help': 'Help',
  'fabric.editor.elementInsertSidePanel.title': 'Insert',
  'fabric.editor.elementbrowser.categorylist.category-admin': 'Administration',
  'fabric.editor.elementbrowser.categorylist.category-ai': 'Rovo',
  'fabric.editor.elementbrowser.categorylist.category-all': 'All',
  'fabric.editor.elementbrowser.categorylist.category-communication': 'Communication',
  'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Confluence content',
  'fabric.editor.elementbrowser.categorylist.category-development': 'Development',
  'fabric.editor.elementbrowser.categorylist.category-external-content': 'External content',
  'fabric.editor.elementbrowser.categorylist.category-formatting': 'Formatting',
  'fabric.editor.elementbrowser.categorylist.category-media': 'Media',
  'fabric.editor.elementbrowser.categorylist.category-navigation': 'Navigation',
  'fabric.editor.elementbrowser.categorylist.category-reporting': 'Reporting',
  'fabric.editor.elementbrowser.categorylist.category-visuals': 'Visuals & images',
  'fabric.editor.elementbrowser.featured.whiteboard.description': 'Use a whiteboard to add visuals to your page',
  'fabric.editor.elementbrowser.search.empty-state.heading': 'Nothing matches your search',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading':
    'Try searching with a different term or discover new apps for Atlassian products.',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': 'Explore Atlassian Marketplace',
  'fabric.editor.elementbrowser.searchbar.assistive.text.default':
    '{count, plural, =0 {Nothing matches your search.} one {{count} suggestion available by default.} other {{count} suggestions available by default.}}',
  'fabric.editor.elementbrowser.searchbar.assistive.text.result':
    '{count, plural, =0 {Nothing matches your search.} one {{count} suggestion available for typed text.} other {{count} suggestions available for typed text.}}',
  'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Enter',
  'fabric.editor.elementbrowser.searchbar.placeholder': 'Search',
  'fabric.editor.elementbrowser.sidebar.heading': 'Browse',
  'fabric.editor.embedTitle': 'Embed',
  'fabric.editor.embedToBlockCardWarning': 'Displays as a card on small screens',
  'fabric.editor.emoji': 'Emoji',
  'fabric.editor.emoji.description': 'Use emojis to express ideas 🎉 and emotions 😄',
  'fabric.editor.emptyLink': 'Please enter a link.',
  'fabric.editor.emptySearchResults': "We couldn't find any results.",
  'fabric.editor.emptySearchResultsSuggestion': 'Select {buttonName} to browse inserts.',
  'fabric.editor.epic': 'Epic',
  'fabric.editor.error': 'Error',
  'fabric.editor.error.description.failToCreateWhenOffline':
    'You appear to be offline. Please connect to the internet to create synced content.',
  'fabric.editor.error.description.failToDeleteWhenOffline':
    'You appear to be offline. Please connect to the internet to delete synced content.',
  'fabric.editor.error.description.failToEditWhenOffline':
    'You appear to be offline. Please connect to the internet to edit synced content.',
  'fabric.editor.error.title.failToCreate': 'Cannot create synced content offline',
  'fabric.editor.error.title.failToDelete': 'Failed to delete',
  'fabric.editor.error.title.failToEdit': 'Cannot edit synced content offline',
  'fabric.editor.errorPanel': 'Error panel',
  'fabric.editor.errorPanel.description': 'Call out errors in a colored panel',
  'fabric.editor.expand': 'Expand',
  'fabric.editor.expand.description': 'Insert an expand',
  'fabric.editor.expandAriaLabel': 'Give this expand a title',
  'fabric.editor.expandDefaultTitle': 'Click here to expand...',
  'fabric.editor.expandNode': 'Expand content',
  'fabric.editor.expandPlaceholder': 'Give this expand a title...',
  'fabric.editor.extension.confirmDeleteLinkedModalMessage': 'Deleting {nodeName} will break anything connected to it.',
  'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': 'Deleting',
  'fabric.editor.extension.confirmDeleteLinkedModalOKButton': 'Delete',
  'fabric.editor.extension.deleteElementTitle': 'Delete element',
  'fabric.editor.extension.sourceNoTitledName': 'this element',
  'fabric.editor.extensions.config-panel.loading-error.non-final':
    'We ran into a bit of trouble. Refresh to try again.',
  'fabric.editor.extensions.config-panel.save-indicator': 'All changes are always autosaved',
  'fabric.editor.externalExtensionsHeading': 'Apps',
  'fabric.editor.externalMediaFile': 'External media file',
  'fabric.editor.failed_to_upload': 'Failed to upload',
  'fabric.editor.feedbackDialog': 'Give feedback',
  'fabric.editor.feedbackDialog.description': 'Tell us about your experience using the cloud editor',
  'fabric.editor.find': 'Find',
  'fabric.editor.findNext': 'Find next',
  'fabric.editor.findPrevious': 'Find previous',
  'fabric.editor.findReplaceToolbarButton': 'Find and replace',
  'fabric.editor.fiveColumns': '5 Column layout',
  'fabric.editor.floatingToolbar.confirmModalCancel': 'Cancel',
  'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': 'Also delete connected elements',
  'fabric.editor.floatingToolbar.confirmModalConnectedUnit':
    '{name}{amount, plural, =0 {} one { (+1 connected element)} other { (+# connected elements)}}',
  'fabric.editor.floatingToolbar.confirmModalHeading': 'Are you sure?',
  'fabric.editor.floatingToolbar.confirmModalOK': 'OK',
  'fabric.editor.floatingToolbar.floatingToolbarAnnouncer': 'Floating toolbar controls have been opened',
  'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': 'Floating Toolbar',
  'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'Layout options',
  'fabric.editor.floatingToolbar.scrollLeft': 'Scroll left',
  'fabric.editor.floatingToolbar.scrollRight': 'Scroll right',
  'fabric.editor.focusTableResizeHandle': 'Focus table resize handle',
  'fabric.editor.fourColumns': '4 Column layout',
  'fabric.editor.headerColumn': 'Header column',
  'fabric.editor.headerRow': 'Header row',
  'fabric.editor.heading1': 'Heading 1',
  'fabric.editor.heading1Description': 'Use this for a top level heading',
  'fabric.editor.heading2': 'Heading 2',
  'fabric.editor.heading2Description': 'Use this for key sections',
  'fabric.editor.heading3': 'Heading 3',
  'fabric.editor.heading3Description': 'Use this for sub sections and group headings',
  'fabric.editor.heading4': 'Heading 4',
  'fabric.editor.heading4Description': 'Use this for deep headings',
  'fabric.editor.heading5': 'Heading 5',
  'fabric.editor.heading5Description': 'Use this for grouping list items',
  'fabric.editor.heading6': 'Heading 6',
  'fabric.editor.heading6Description': 'Use this for low level headings',
  'fabric.editor.headingLink.ascOrderLabel': 'Sort column Z to A',
  'fabric.editor.headingLink.descOrderLabel': 'Clear sorting',
  'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'Blog',
  'fabric.editor.headingLink.hyperlinkIconBugLabel': 'Bug',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel': 'Issue',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': 'Work Item',
  'fabric.editor.headingLink.hyperlinkIconPageLabel': 'Page',
  'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'Story',
  'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'Task',
  'fabric.editor.headingLink.invalidLabel': "⚠️ You can't sort a table with merged cells",
  'fabric.editor.headingLink.noOrderLabel': 'Sort column A to Z',
  'fabric.editor.help': 'Help',
  'fabric.editor.help.description': 'Browse all the keyboard shortcuts and markdown options',
  'fabric.editor.helpDialogTips': 'Press {keyMap} to quickly open this dialog at any time',
  'fabric.editor.highlight': 'Highlight color',
  'fabric.editor.highlight.removeColor': 'Remove color',
  'fabric.editor.highlightColor': 'Toggle highlight color palette',
  'fabric.editor.highlightFloatingToolbar': 'Highlight',
  'fabric.editor.horizontalRule': 'Divider',
  'fabric.editor.horizontalRule.description': 'Separate content with a horizontal line',
  'fabric.editor.hyperlink.linkVisibleLabel': 'Paste or search for link',
  'fabric.editor.hyperlink.searchLinkAriaDescription': 'Suggestions will appear below as you type into the field',
  'fabric.editor.hyperlink.searchLinkResults':
    '{count, plural, =0 {no results} one {# result} other {# results}} found',
  'fabric.editor.hyperlink.textVisibleLabel': 'Display text (optional)',
  'fabric.editor.hyperlinkToolbarPlaceholder': 'Paste or search for link',
  'fabric.editor.image': 'Image',
  'fabric.editor.image.fullWidthLabel': 'Full-width',
  'fabric.editor.imageBorderBold': 'Bold',
  'fabric.editor.imageBorderColor': 'Color',
  'fabric.editor.imageBorderColor.dropdownAriaLabel': 'Image border options Color dropdown',
  'fabric.editor.imageBorderMedium': 'Medium',
  'fabric.editor.imageBorderOptions': 'Border options',
  'fabric.editor.imageBorderSize': 'Size',
  'fabric.editor.imageBorderSize.dropdownAriaLabel': 'Image border options Size dropdown',
  'fabric.editor.imageBorderSubtle': 'Subtle',
  'fabric.editor.improvement': 'Improvement',
  'fabric.editor.increaseElementSize': 'Increase element size',
  'fabric.editor.increaseSize': 'Increase table or media size',
  'fabric.editor.indent': 'Indent',
  'fabric.editor.info': 'Info',
  'fabric.editor.infoPanel': 'Info panel',
  'fabric.editor.infoPanel.description': 'Highlight information in a colored panel',
  'fabric.editor.inlineConfigureLink': 'Configure link',
  'fabric.editor.inlineDescription': 'Display link as inline text',
  'fabric.editor.inlineGoToLink': 'Go to link',
  'fabric.editor.inlineOverlay': 'Configure',
  'fabric.editor.inlineTitle': 'Inline',
  'fabric.editor.inputQueryAssistiveTxt':
    'When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.',
  'fabric.editor.insertColumn': 'Insert column right',
  'fabric.editor.insertColumnDrag': 'Insert column',
  'fabric.editor.insertMenu': 'Insert elements',
  'fabric.editor.insertRightRail.close': 'Close',
  'fabric.editor.insertRightRail.title': 'Insert',
  'fabric.editor.insertRow': 'Insert row below',
  'fabric.editor.insertRowDrag': 'Insert row',
  'fabric.editor.insertTableColumn': 'Insert table column',
  'fabric.editor.insertTableRow': 'Insert table row',
  'fabric.editor.invalidDateError': 'Enter a valid date',
  'fabric.editor.invalidLink': 'Please enter a valid link.',
  'fabric.editor.inviteItem.title':
    '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
  'fabric.editor.italic': 'Italic',
  'fabric.editor.keyboardShortcuts': 'Keyboard shortcuts',
  'fabric.editor.layout.columnOption': '{count, plural, one {{count} Column} other {{count} Columns}}',
  'fabric.editor.layout.controls.placeholder': '/ to insert',
  'fabric.editor.layout.placeholder': 'Add content',
  'fabric.editor.layout.resizeLayout': 'Resize layout',
  'fabric.editor.layoutFixedWidth': 'Back to center',
  'fabric.editor.layoutFullWidth': 'Go full width',
  'fabric.editor.layoutStateFixedWidth': 'Centered',
  'fabric.editor.layoutStateFullWidth': 'Full width',
  'fabric.editor.layoutStateWide': 'Wide',
  'fabric.editor.layoutWide': 'Go wide',
  'fabric.editor.leftSidebar': 'Left sidebar layout',
  'fabric.editor.limitedModeDescription':
    'To increase speed and response time <learnMoreLink>some editing features are limited</learnMoreLink>.',
  'fabric.editor.limitedModeDescriptionWithoutLink':
    'To increase speed and response time some editing features are limited.',
  'fabric.editor.limitedModeTitle': 'Speed improvements',
  'fabric.editor.link': 'Link',
  'fabric.editor.link.description': 'Insert a link',
  'fabric.editor.linkAddress': 'Link address',
  'fabric.editor.linkPlaceholder': 'Paste link',
  'fabric.editor.lists': 'Lists',
  'fabric.editor.listsFormat': 'List formatting',
  'fabric.editor.lockColumns': 'Fixed column widths',
  'fabric.editor.longEmptyNodePlaceholderPrefix': 'Type',
  'fabric.editor.longEmptyNodePlaceholderSlash': '/',
  'fabric.editor.longEmptyNodePlaceholderSuffix': 'to insert elements',
  'fabric.editor.longEmptyNodePlaceholderText': 'Type / to insert elements',
  'fabric.editor.markdown': 'Markdown',
  'fabric.editor.matchCase': 'Match case',
  'fabric.editor.media.DefaultMediaWidthDecreased':
    '{newMediaWidth, plural, one {Media width decreased to # pixel.} other {Media width decreased to # pixels.}}',
  'fabric.editor.media.DefaultMediaWidthIncreased':
    '{newMediaWidth, plural, one {Media width increased to # pixel.} other {Media width increased to # pixels.}}',
  'fabric.editor.media.MediaWidthIsMin': 'Media decreased to the minimum size',
  'fabric.editor.media.insert.cancel': 'Cancel',
  'fabric.editor.media.insert.fileTabTitle': 'File',
  'fabric.editor.media.insert.fromUrlErrorMessage':
    'Unfortunately, we can’t add this image link. Download the image, then drag and drop onto the page.',
  'fabric.editor.media.insert.fromUrlWarning':
    'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
  'fabric.editor.media.insert.insert': 'Insert',
  'fabric.editor.media.insert.invalidUrlErrorMessage': 'Invalid link',
  'fabric.editor.media.insert.linkTabTitle': 'Link',
  'fabric.editor.media.insert.loadPreview': 'Load preview',
  'fabric.editor.media.insert.localFileErrorMessage': 'This file couldn’t be uploaded.',
  'fabric.editor.media.insert.localFileNetworkErrorMessage': 'File upload error. Check file path or network.',
  'fabric.editor.media.insert.mediaAlt': 'Preview for uploaded image or video file',
  'fabric.editor.media.insert.mediaPickerPopupAriaLabel': 'Media picker',
  'fabric.editor.media.insert.pasteLinkToUpload': 'Paste link to upload',
  'fabric.editor.media.insert.upload': 'Upload',
  'fabric.editor.media.pixelEntry.MediaWidthIsMax': 'Media increased to the maximum size',
  'fabric.editor.media.pixelEntry.ResizeOption': 'Resize',
  'fabric.editor.media.pixelEntry.closePixelEntry': 'Close',
  'fabric.editor.media.pixelEntry.inputHeightAriaLabel': 'height input',
  'fabric.editor.media.pixelEntry.inputHeightTooltip': 'Height',
  'fabric.editor.media.pixelEntry.inputWidthAriaLabel': 'Max width {maxWidth}px',
  'fabric.editor.media.pixelEntry.inputWidthLabel': 'Width',
  'fabric.editor.media.pixelEntry.inputWidthTooltip': 'Max width {maxWidth}px',
  'fabric.editor.media.pixelEntry.migrationButtonText': 'Convert to pixels',
  'fabric.editor.media.pixelEntry.migrationButtonTooltip': 'Migrate from percentage to fixed pixel sizing',
  'fabric.editor.media.pixelEntry.submitButtonText': 'Submit',
  'fabric.editor.media.pixelEntry.validationFailedMessage': 'Validation for width failed',
  'fabric.editor.mediaAddLink': 'Add link',
  'fabric.editor.mediaFiles': 'Image, video, or file',
  'fabric.editor.mediaFiles.description': 'Add images and other files to your page',
  'fabric.editor.mediaGroupDeleteLabel': 'delete',
  'fabric.editor.media_change_mediainline_caption_warn': 'Inline (caption will be removed)',
  'fabric.editor.media_change_mediainline_default': 'Inline',
  'fabric.editor.media_change_mediasingle': 'Original size',
  'fabric.editor.mention': 'Mention',
  'fabric.editor.mention.description': 'Mention someone to send them a notification',
  'fabric.editor.mentionNode.label': 'Tagged user',
  'fabric.editor.mentionsAddLabel': 'add-icon',
  'fabric.editor.mentionsIconLabel': 'Mention',
  'fabric.editor.mergeCells': 'Merge cells',
  'fabric.editor.moreFormatting': 'More formatting',
  'fabric.editor.moveColumnLeft': 'Move {0, plural, one {column} other {columns}} left',
  'fabric.editor.moveColumnRight': 'Move {0, plural, one {column} other {columns}} right',
  'fabric.editor.moveDownDown': 'Move {0, plural, one {row} other {rows}} down',
  'fabric.editor.moveRowUp': 'Move {0, plural, one {row} other {rows}} up',
  'fabric.editor.navigate.toolbar.askAI': 'Ask AI',
  'fabric.editor.navigate.toolbar.editor': 'Navigate to editor toolbar',
  'fabric.editor.navigate.toolbar.floating': 'Navigate to floating toolbar',
  'fabric.editor.noPermissionToAddComment':
    '{contentType, select, blogpost {You do not have permission to add comments to this blogpost} page {You do not have permission to add comments to this page} other {You do not have permission to add comments to this page}}',
  'fabric.editor.noResultsFound': 'No results',
  'fabric.editor.noSearchResults': 'No search results',
  'fabric.editor.normal': 'Normal text',
  'fabric.editor.note': 'Note',
  'fabric.editor.notePanel': 'Note panel',
  'fabric.editor.notePanel.description': 'Add a note in a colored panel',
  'fabric.editor.numberedColumn': 'Numbered column',
  'fabric.editor.off': '{formattingType} Off',
  'fabric.editor.on': '{formattingType} On',
  'fabric.editor.openButtonTitle': 'Open',
  'fabric.editor.openCellOptions': 'Open cell options',
  'fabric.editor.openLink': 'Open link in a new tab',
  'fabric.editor.openPreviewPanel': 'Open preview panel',
  'fabric.editor.orderedList': 'Numbered list',
  'fabric.editor.orderedList.description': 'Create an ordered list',
  'fabric.editor.other': 'Others...',
  'fabric.editor.outdent': 'Outdent',
  'fabric.editor.overflowMenuViewMore': 'View more',
  'fabric.editor.pageActionsLabel': 'Page actions',
  'fabric.editor.panel': 'Panel',
  'fabric.editor.panel.backgroundColor': 'Background color',
  'fabric.editor.panel.custom': 'Custom',
  'fabric.editor.panel.emoji': 'Add emoji',
  'fabric.editor.panel.panelsGroup': 'Panel Types',
  'fabric.editor.panelButtonTitle': 'Panel',
  'fabric.editor.pasteOptions': 'Paste options',
  'fabric.editor.pastePlainText': 'Paste plain text',
  'fabric.editor.placeholderAltText': 'Describe this image with alt text',
  'fabric.editor.placeholderText': 'Placeholder text',
  'fabric.editor.placeholderText.description': 'Insert a text placeholder into the page',
  'fabric.editor.placeholderTextPlaceholder': 'Add placeholder text',
  'fabric.editor.plainText': 'Use plain text',
  'fabric.editor.preferencesLink': 'Link preferences',
  'fabric.editor.previewButtonTitle': 'Preview',
  'fabric.editor.quickInsert': 'Quick insert',
  'fabric.editor.quickinsert.new.lozenge': 'New',
  'fabric.editor.recordLoomShortTitle': 'Record',
  'fabric.editor.recordVideo': 'Record a Loom video',
  'fabric.editor.recordVideo.description': 'Record and share your screen and thoughts',
  'fabric.editor.redo': 'Redo',
  'fabric.editor.referenceSyncBlockTooltip': 'Synced from: {title}',
  'fabric.editor.remove': 'Remove',
  'fabric.editor.removeColumns': 'Delete {0, plural, one {column} other {columns}}',
  'fabric.editor.removeEmoji': 'Remove emoji',
  'fabric.editor.removeImageBorder': 'Remove border',
  'fabric.editor.removeRows': 'Delete {0, plural, one {row} other {rows}}',
  'fabric.editor.replace': 'Replace',
  'fabric.editor.replaceAll': 'Replace all',
  'fabric.editor.replaceSuccess': '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
  'fabric.editor.replaceWith': 'Replace with',
  'fabric.editor.requestAccessToSyncedBlock': 'Request access',
  'fabric.editor.requestAccessToSyncedBlockError': 'Something went wrong. Click to try again',
  'fabric.editor.requestToEdit': 'Request to edit',
  'fabric.editor.requestToEditDescription': 'When you request access, the page owner will receive a notification.',
  'fabric.editor.requestToEditDismiss': 'Dismiss',
  'fabric.editor.resizeHandle': 'Resize handle',
  'fabric.editor.resultsCount': '{selectedMatchPosition} of {totalResultsCount}',
  'fabric.editor.retrySyncedBlock': 'Retry',
  'fabric.editor.richText': 'Use rich text',
  'fabric.editor.rightSidebar': 'Right sidebar layout',
  'fabric.editor.rowControl': 'Highlight row',
  'fabric.editor.rowDragHandle': 'Row options',
  'fabric.editor.rowMovedDown': 'Row moved down to {index} of {total}',
  'fabric.editor.rowMovedUp': 'Row moved up to {index} of {total}',
  'fabric.editor.rowSelected': 'Row {index} of {total} selected',
  'fabric.editor.rowsAreInserted': '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
  'fabric.editor.rowsAreRemoved': '{count, plural, one {The row has been} other {{count} rows have been}} removed',
  'fabric.editor.saveButton': 'Save',
  'fabric.editor.searchResults':
    '{itemsLength, plural, one {# search result} other {# search results}} available. Use Up and Down arrow keys to navigate amongst the options. Press Enter to select an option.',
  'fabric.editor.selectColumnResize': 'Select column resize',
  'fabric.editor.selectLanguage': 'Select language',
  'fabric.editor.selectTableColumn': 'Select table column',
  'fabric.editor.selectTableRow': 'Select table row',
  'fabric.editor.selectionExtensionDropdownButtonLabel': 'Select app',
  'fabric.editor.selectionToolbarOverflowMenuTooltip': 'More options',
  'fabric.editor.settingsLinks': 'Go to Link Preferences',
  'fabric.editor.shortEmptyNodePlaceholderSlash': '/',
  'fabric.editor.shortEmptyNodePlaceholderSuffix': 'to insert',
  'fabric.editor.shortEmptyNodePlaceholderText': '/ to insert',
  'fabric.editor.shortcut': 'Text shortcut',
  'fabric.editor.single': 'Single column layout',
  'fabric.editor.singleColumns': '1 Column layout',
  'fabric.editor.sortColumnASC': 'Sort column A → Z',
  'fabric.editor.sortColumnDESC': 'Sort column Z → A',
  'fabric.editor.sortColumnDecreasing': 'Sort decreasing',
  'fabric.editor.sortColumnIncreasing': 'Sort increasing',
  'fabric.editor.sourceSyncBlockTooltip': 'Synced block',
  'fabric.editor.splitCell': 'Split cell',
  'fabric.editor.status': 'Status',
  'fabric.editor.status.description': 'Add a custom status label',
  'fabric.editor.statusEditorLabel': 'Status editor',
  'fabric.editor.statusPickerOpenedAlert': 'Status editor popup opened, press Tab to access popup',
  'fabric.editor.statusPlaceholder': 'Set a status',
  'fabric.editor.story': 'Story',
  'fabric.editor.strike': 'Strikethrough',
  'fabric.editor.subTask': 'Sub-task',
  'fabric.editor.subscript': 'Subscript',
  'fabric.editor.subscript.off.superscript.on': 'Subscript Off, Superscript On',
  'fabric.editor.success': 'Success',
  'fabric.editor.successPanel': 'Success panel',
  'fabric.editor.successPanel.description': 'Add tips in a colored panel',
  'fabric.editor.superscript': 'Superscript',
  'fabric.editor.superscript.off.subscript.on': 'Superscript Off, Subscript On',
  'fabric.editor.supportAltText': 'Alt text is useful for people using screen readers because of visual limitations.',
  'fabric.editor.syncBlock.toolbar.newLozenge': 'New',
  'fabric.editor.syncBlockGroup': 'Sync Block Types',
  'fabric.editor.syncBlockPlaceholderText': 'Add content then copy this synced block to access it across spaces',
  'fabric.editor.syncedBlock': 'Create synced block',
  'fabric.editor.syncedBlock.description': 'Sync content across multiple locations',
  'fabric.editor.syncedBlockGeneralErrorDescription': 'Something went wrong while loading this synced block.',
  'fabric.editor.syncedBlockNotFoundDescription': 'We’re unable to load this synced block.',
  'fabric.editor.syncedBlockNotFoundIconAltText': 'Synced block not found.',
  'fabric.editor.syncedBlockPermissionDeniedDescription':
    "The source of this synced block is a content item you don't have access to.",
  'fabric.editor.syncedBlockPermissionDeniedHeading': "You don't have permission to view this synced block",
  'fabric.editor.syncedBlockPermissionDeniedIconAltText': 'Permission denied.',
  'fabric.editor.table': 'Table',
  'fabric.editor.table.description': 'Insert a table',
  'fabric.editor.tableAlignmentOptions': 'Alignment options',
  'fabric.editor.tableFullWidthLabel': 'Full-width',
  'fabric.editor.tableHeader.sorting.asc': 'Ascending sort applied',
  'fabric.editor.tableHeader.sorting.default': 'Sort the column',
  'fabric.editor.tableHeader.sorting.desc': 'Descending sort applied',
  'fabric.editor.tableHeader.sorting.invalid': "You can't sort a table with merged cells",
  'fabric.editor.tableHeader.sorting.no': 'No sort applied to the column',
  'fabric.editor.tableOptions': 'Table options',
  'fabric.editor.tableResizeDecreaseScreenReaderInformation':
    'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
  'fabric.editor.tableResizeIncreaseScreenReaderInformation':
    'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
  'fabric.editor.tableScrollRegion': 'Table scroll region',
  'fabric.editor.tableSelector': 'Table size',
  'fabric.editor.tableSelector.description': 'Add a table using popup to select a custom size',
  'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} by {numberOfRows}',
  'fabric.editor.tableSizeSelectorPopup': 'Table size selector',
  'fabric.editor.tables.adjustColumn': 'Adjust column',
  'fabric.editor.tables.columnResizeLast': 'You can only resize this column to the left.',
  'fabric.editor.tables.columnResizeOverflow': 'You can only resize this column while the table has a scroll bar.',
  'fabric.editor.tables.columnWidth':
    '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
  'fabric.editor.tables.confirmDeleteLinkedModalMessage': 'Deleting {nodeName} will break anything connected to it.',
  'fabric.editor.tables.confirmDeleteLinkedModalOKButton': 'Delete',
  'fabric.editor.tables.otherResize':
    '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
  'fabric.editor.tables.resizeStop': 'Stopped resize',
  'fabric.editor.tables.resizeTable': 'Resize table',
  'fabric.editor.tables.startedColumnResize': 'Started column resize',
  'fabric.editor.task': 'Task',
  'fabric.editor.taskDecision.markTaskAsCompleted': 'Mark task as completed',
  'fabric.editor.taskDecision.markTaskAsNotCompleted': 'Mark task as not completed',
  'fabric.editor.taskList': 'Task list',
  'fabric.editor.taskPlaceholder': "Type your action, use '@' to assign to someone.",
  'fabric.editor.text.formatting.off': 'Text formatting Off',
  'fabric.editor.textColor': '{selectedColorName} Text color',
  'fabric.editor.textColorHighlightTooltip': 'Text and Highlight color',
  'fabric.editor.textColorTooltip': 'Text color',
  'fabric.editor.textFormat': 'Format text',
  'fabric.editor.textFormatting': 'Text formatting',
  'fabric.editor.textStyles': '{blockTypeName} Text styles',
  'fabric.editor.textStylesTooltip': 'Text styles',
  'fabric.editor.threeColumns': '3 Column layout',
  'fabric.editor.threeColumnsWithLeftSidebars': 'Three columns with left sidebar layout',
  'fabric.editor.threeColumnsWithRightSidebars': 'Three columns with right sidebar layout',
  'fabric.editor.threeColumnsWithSidebars': 'Three columns with sidebars layout',
  'fabric.editor.time.ago': 'ago',
  'fabric.editor.time.updated': 'Updated',
  'fabric.editor.time.viewed': 'Viewed',
  'fabric.editor.toolbarAppears': 'Toolbar appears',
  'fabric.editor.toolbarLabel': 'Editor',
  'fabric.editor.toolbarMediaTitle': 'Add image, video, or file',
  'fabric.editor.toolbarPositionFixedAtTop': 'Fixed at top',
  'fabric.editor.toolbarPositionInline': 'In-line with text',
  'fabric.editor.toolbarPositionPinedAtTop': 'Unpin the toolbar',
  'fabric.editor.toolbarPositionUnpined': 'Pin the toolbar at the top',
  'fabric.editor.toolbarPositionUnpinnedConcise': 'Pin toolbar to top',
  'fabric.editor.tooltip.blockPanel': 'a panel',
  'fabric.editor.tooltip.bulletList': 'a list',
  'fabric.editor.tooltip.decisionList': 'a decision list',
  'fabric.editor.tooltip.defaultBlockNode': 'a block node',
  'fabric.editor.tooltip.nestedExpand': 'a nested expand',
  'fabric.editor.tooltip.taskList': 'an action item',
  'fabric.editor.turnInto': 'Turn into',
  'fabric.editor.twoColumns': '2 Column layout',
  'fabric.editor.typeAhead.popupLabel': 'Typeahead results',
  'fabric.editor.typeAhead.quickInsertInputLabel': 'Begin typing to search or filter shortcut options',
  'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': 'Search',
  'fabric.editor.typeAhead.quickInsertPopupLabel': 'Shortcuts for inserts and formatting',
  'fabric.editor.typeAheadErrorFallbackDescription': 'No results available. Try again.',
  'fabric.editor.typeAheadErrorFallbackHeading': 'Something went wrong',
  'fabric.editor.typeahead.emojiInputLabel': 'Begin typing to search or filter emoji options',
  'fabric.editor.typeahead.emojiListItemLabel': 'Emoji {name} Text Shortcut {shortcut}',
  'fabric.editor.typeahead.emojiPopupLabel': 'Emoji shortcuts',
  'fabric.editor.typeahead.mentionInputLabel': 'Begin typing to search for users to tag',
  'fabric.editor.typeahead.mentionPopupLabel': 'Users you can tag',
  'fabric.editor.typeahead.metionListItemLabel': 'User {name} @{shortName}',
  'fabric.editor.unableToLoadContent': "We couldn't load this content",
  'fabric.editor.unableToOpenLink': 'Unable to open this link',
  'fabric.editor.underline': 'Underline',
  'fabric.editor.undo': 'Undo',
  'fabric.editor.unknown.label': 'Unknown',
  'fabric.editor.unlink': 'Unlink',
  'fabric.editor.unorderedList': 'Bullet list',
  'fabric.editor.unorderedList.description': 'Create an unordered list',
  'fabric.editor.unsupportedBlockContent': 'This editor does not support displaying this content',
  'fabric.editor.unsupportedContentTooltip':
    'Content is not available in this editor, this will be preserved when you edit and save',
  'fabric.editor.unsupportedInlineContent': 'Unsupported content',
  'fabric.editor.upDown':
    'On the use of up and down arrow keys into the following input field, the date will update below',
  'fabric.editor.url': 'Display URL',
  'fabric.editor.urlDescription': 'Display link as URL',
  'fabric.editor.urlTitle': 'URL',
  'fabric.editor.useMarkdown': 'Use Markdown',
  'fabric.editor.viewAndAddCommentsOnMedia': 'View and add comments',
  'fabric.editor.viewCommentOnMedia': 'View comments',
  'fabric.editor.viewMore': 'View more',
  'fabric.editor.viewMoreAriaLabel': 'View all elements',
  'fabric.editor.visit': 'Open link in a new window',
  'fabric.editor.warning': 'Warning',
  'fabric.editor.warningPanel': 'Warning panel',
  'fabric.editor.warningPanel.description': 'Add a note of caution in a colored panel',
  'fabric.editor.wrapLeft': 'Wrap left',
  'fabric.editor.wrapRight': 'Wrap right',
  'fabric.emoji.label': 'Emoji',
  'fabric.theme.blue': 'Blue',
  'fabric.theme.bold-blue': 'Bold blue',
  'fabric.theme.bold-gray': 'Bold gray',
  'fabric.theme.bold-green': 'Bold green',
  'fabric.theme.bold-magenta': 'Bold magenta',
  'fabric.theme.bold-orange': 'Bold orange',
  'fabric.theme.bold-purple': 'Bold purple',
  'fabric.theme.bold-red': 'Bold red',
  'fabric.theme.bold-teal': 'Bold teal',
  'fabric.theme.bold-yellow': 'Bold yellow',
  'fabric.theme.bolder-blue': 'Bolder blue',
  'fabric.theme.bolder-gray': 'Bolder gray',
  'fabric.theme.bolder-green': 'Bolder green',
  'fabric.theme.bolder-magenta': 'Bolder magenta',
  'fabric.theme.bolder-orange': 'Bolder orange',
  'fabric.theme.bolder-purple': 'Bolder purple',
  'fabric.theme.bolder-red': 'Bolder red',
  'fabric.theme.bolder-teal': 'Bolder teal',
  'fabric.theme.bolder-yellow': 'Bolder yellow',
  'fabric.theme.dark-blue': 'Dark blue',
  'fabric.theme.dark-gray': 'Dark gray',
  'fabric.theme.dark-green': 'Dark green',
  'fabric.theme.dark-purple': 'Dark purple',
  'fabric.theme.dark-red': 'Dark red',
  'fabric.theme.dark-teal': 'Dark teal',
  'fabric.theme.dark-yellow': 'Dark yellow',
  'fabric.theme.default': 'Default',
  'fabric.theme.gray': 'Gray',
  'fabric.theme.green': 'Green',
  'fabric.theme.light-blue': 'Light blue',
  'fabric.theme.light-gray': 'Light gray',
  'fabric.theme.light-green': 'Light green',
  'fabric.theme.light-purple': 'Light purple',
  'fabric.theme.light-red': 'Light red',
  'fabric.theme.light-teal': 'Light teal',
  'fabric.theme.light-yellow': 'Light yellow',
  'fabric.theme.lime': 'Lime',
  'fabric.theme.magenta': 'Magenta',
  'fabric.theme.no-color': 'No highlight',
  'fabric.theme.orange': 'Orange',
  'fabric.theme.purple': 'Purple',
  'fabric.theme.red': 'Red',
  'fabric.theme.subtle-blue': 'Subtle blue',
  'fabric.theme.subtle-gray': 'Subtle gray',
  'fabric.theme.subtle-green': 'Subtle green',
  'fabric.theme.subtle-magenta': 'Subtle magenta',
  'fabric.theme.subtle-orange': 'Subtle orange',
  'fabric.theme.subtle-purple': 'Subtle purple',
  'fabric.theme.subtle-red': 'Subtle red',
  'fabric.theme.subtle-teal': 'Subtle teal',
  'fabric.theme.subtle-yellow': 'Subtle yellow',
  'fabric.theme.teal': 'Teal',
  'fabric.theme.white': 'White',
  'fabric.theme.yellow': 'Yellow',
  'fabrid.editor.rowNumbers': 'Row numbers',
  'rovo.agents.dropdown.title': 'Agents',
  'rovo.agents.dropdown.viewAgents.label': 'View all agents',
};
